/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1740614400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Thu Feb 27 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "hubspot",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Understand your HubSpot setup",
          "depth": 0,
          "id": "understand-your-hubspot-setup"
        }, {
          "value": "Business goals",
          "depth": 1,
          "id": "business-goals"
        }, {
          "value": "Required data specifications",
          "depth": 1,
          "id": "required-data-specifications"
        }, {
          "value": "Inspect objects, properties, and associations",
          "depth": 1,
          "id": "inspect-objects-properties-and-associations"
        }, {
          "value": "Connect to HubSpot",
          "depth": 0,
          "id": "connect-to-hubspot"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing objects",
          "depth": 1,
          "id": "syncing-objects"
        }, {
          "value": "Syncing events",
          "depth": 1,
          "id": "syncing-events"
        }, {
          "value": "Syncing contact lists",
          "depth": 1,
          "id": "syncing-contact-lists"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Date values",
          "depth": 1,
          "id": "date-values"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      p: "p",
      a: "a",
      h3: "h3",
      ul: "ul",
      li: "li",
      ol: "ol",
      img: "img",
      h4: "h4",
      code: "code",
      h5: "h5",
      pre: "pre",
      span: "span"
    }, _provideComponents(), props.components), {DownloadLink, EventSyncWarning, TimestampTemplateMapping, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!DownloadLink) _missingMdxReference("DownloadLink", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    if (!TimestampTemplateMapping) _missingMdxReference("TimestampTemplateMapping", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Objects"
              })
            }), _jsx(_components.td, {
              children: "Sync records to objects such as contacts or companies in HubSpot."
            }), _jsx(_components.td, {
              children: "Upsert, Update, Insert"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Events"
              })
            }), _jsx(_components.td, {
              children: "Sync records as events to HubSpot. This is often in the form of a track call."
            }), _jsx(_components.td, {
              children: "Insert"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Segments"
              })
            }), _jsx(_components.td, {
              children: "Create, sync, and keep contact lists up-to-date in HubSpot."
            }), _jsx(_components.td, {
              children: "Add, Remove"
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "understand-your-hubspot-setup",
        children: "Understand your HubSpot setup"
      }), "\n", _jsxs(_components.p, {
        children: ["Before you begin your Hightouch to HubSpot sync configuration, clarifying your business goals and understanding your HubSpot setup is crucial. Walk through the following considerations to ensure your team is aligned and your sync plans are clear. If you prefer, you can ", _jsx(DownloadLink, {
          href: "https://cdn.sanity.io/files/pwmfmi47/production/b3c4f849dd2b6b85800cf56308af0a5dd7843cd1.pdf",
          fileName: "HubSpot Sync Configuration Considerations",
          children: "download this resource as a PDF"
        }), " to share with your team."]
      }), "\n", _jsx(_components.h3, {
        id: "business-goals",
        children: "Business goals"
      }), "\n", _jsx(_components.p, {
        children: "First, you need to plan what data you want to sync to HubSpot, how you want to update it, and how frequently you want to update it. Consider your business needs and consult with your team to align on the answers to these questions."
      }), "\n", _jsx(_components.p, {
        children: "The following table shows how the responses affect your sync configuration."
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: _jsx("div", {
                style: {
                  width: "250px"
                },
                children: "Consideration"
              })
            }), _jsx(_components.th, {
              children: "Effect on sync configuration"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "What standard and custom objects do you want to sync to HubSpot? Contacts, companies, etc.?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "#supported-syncing",
                children: "sync types"
              }), "—in other words, which objects you select to sync to. You need to set up a separate sync configuration for each object you want to sync to."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "What standard and custom properties do these objects have that you want to sync to?"
            }), _jsxs(_components.td, {
              children: ["The response affects the ", _jsx(_components.a, {
                href: "#field-mapping",
                children: "field mapping"
              }), " on each of your syncs."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Do you have new data to add, old data that needs updating, or a combination of both?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "#supported-syncing",
                children: "sync modes"
              }), "—for example, insert mode for new data, update mode for old, and upsert mode for both."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "How frequently do you need to update the data?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "/syncs/schedule-sync-ui",
                children: "sync schedule"
              }), ". This is the last step of your sync configuration."]
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["To learn what objects and properties you are using in your HubSpot instance, follow ", _jsx(_components.a, {
          href: "#inspect-objects-properties-and-associations",
          children: "these steps"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "required-data-specifications",
        children: "Required data specifications"
      }), "\n", _jsx(_components.p, {
        children: "Once you've confirmed the objects and properties you want to sync, you need to confirm that:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "they have the correct data types"
        }), "\n", _jsx(_components.li, {
          children: "you have permission to edit them"
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["You can find the answers to these questions by following ", _jsx(_components.a, {
          href: "#inspect-objects-properties-and-associations",
          children: "these steps"
        }), "."]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: _jsx("div", {
                style: {
                  width: "250px"
                },
                children: "Consideration"
              })
            }), _jsx(_components.th, {
              children: "Effect on sync configuration"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["Is the property that you would like to use for ", _jsx(_components.a, {
                href: "#record-matching",
                children: "record matching"
              }), " unique?"]
            }), _jsx(_components.td, {
              children: "Non-unique values can lead to duplicates and sync errors."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "What are the expected data types of the properties you want to sync to?"
            }), _jsxs(_components.td, {
              children: ["The response affects your ", _jsx(_components.a, {
                href: "#field-mapping",
                children: "field mapping"
              }), "; if the expected type differs from your model column type, you must ", _jsx(_components.a, {
                href: "https://hightouch.com/docs/models/data-types-casting",
                children: "type cast your data"
              }), " in your model configuration."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Are the properties you want to sync editable?"
            }), _jsxs(_components.td, {
              children: ["Hightouch only displays editable fields during ", _jsx(_components.a, {
                href: "#field-mapping",
                children: "field mapping"
              }), "."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["Are any of the properties you want to sync ", _jsx(_components.a, {
                href: "https://community.hubspot.com/t5/Tips-Tricks-Best-Practices/Using-calculated-properties/m-p/372525",
                children: "calculated"
              }), " properties?"]
            }), _jsx(_components.td, {
              children: "Calculation properties are non-editable and read-only. Change the field type if you want to sync data to it."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsxs(_components.td, {
              children: ["Are any of the properties you want to sync ", _jsx(_components.a, {
                href: "https://knowledge.hubspot.com/account/property-field-types-in-hubspot",
                children: "enumeration"
              }), " properties?"]
            }), _jsx(_components.td, {
              children: "Enumeration properties only accept specific values. Ensure your data matches these values or create a new property."
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Are there any associations you want to make between objects?"
            }), _jsxs(_components.td, {
              children: ["You can set up ", _jsx(_components.a, {
                href: "#associations",
                children: "associations"
              }), " while field mapping, assuming the association exists in HubSpot first."]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: "Does the user you are authenticating to Hightouch have edit access?"
            }), _jsx(_components.td, {
              children: "The sync will error if the user doesn't have the correct permissions."
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "inspect-objects-properties-and-associations",
        children: "Inspect objects, properties, and associations"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["In your HubSpot account, click the settings icon in the main navigation bar. Under ", _jsx(_components.strong, {
            children: "Data Management"
          }), " > ", _jsx(_components.strong, {
            children: "Objects"
          }), ", select the object you want to inspect, such as ", _jsx(_components.strong, {
            children: "Contacts"
          }), ", ", _jsx(_components.strong, {
            children: "Companies"
          }), ", ", _jsx(_components.strong, {
            children: "Deals"
          }), ", etc."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-objects.png",
          alt: "Inspecting objects in the HubSpot UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsxs(_components.li, {
          children: ["In the object's overview page, under ", _jsx(_components.strong, {
            children: "Setup"
          }), ", click ", _jsx(_components.strong, {
            children: "Manage [object] properties"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-properties.png",
          alt: "Inspecting properties in HubSpot UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsx(_components.li, {
          children: "Review both standard and custom properties you want to sync data to. Make note of their:"
        }), "\n"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Internal name"
          }), ": This is the name that appears in the Hightouch UI for ", _jsx(_components.a, {
            href: "#record-matching",
            children: "record matching"
          }), " and ", _jsx(_components.a, {
            href: "#field-mapping",
            children: "field mapping"
          }), ". You can access it by clicking on the property name and then clicking ", _jsx(_components.strong, {
            children: "</>"
          }), " in the property inspector."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-internal-name.png",
          alt: "Inspecting a property's internal name"
        })
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "Property access"
            }), ": The HubSpot user you use to ", _jsx(_components.a, {
              href: "#connect-to-hubspot",
              children: "authenticate to Hightouch"
            }), " should have access to edit the property."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "Data type"
            }), ": For example, ", _jsx(_components.strong, {
              children: "Single-line text"
            }), " or ", _jsx(_components.strong, {
              children: "Number"
            }), "—you can view these under the property ", _jsx(_components.strong, {
              children: "Name"
            }), ". When selecting model columns for ", _jsx(_components.a, {
              href: "#field-mapping",
              children: "field mapping"
            }), ", you must ensure the data type matches. For example, a ", _jsx(_components.strong, {
              children: "Single-line text"
            }), " property requires text data and a ", _jsx(_components.strong, {
              children: "Number"
            }), " requires numerical data."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-type-and-access.png",
          alt: "Inspecting a property's data type and access"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsxs(_components.li, {
          children: ["Check whether any of the properties you plan on syncing to are an enumeration type, such as ", _jsx(_components.strong, {
            children: "Dropdown select"
          }), ", ", _jsx(_components.strong, {
            children: "Radio select"
          }), ", or ", _jsx(_components.strong, {
            children: "Multiple checkboxes"
          }), ". For example, the native ", _jsx(_components.strong, {
            children: "Lead rating"
          }), " property for contacts is a ", _jsx(_components.strong, {
            children: "radio select"
          }), " property."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-lead-rating.png",
          alt: "Lead rating property in HubSpot UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you plan on syncing to enumeration properties, the data you sync must match the ", _jsx(_components.strong, {
          children: "internal value"
        }), " of the options. Lead rating, for example, can accept the values \"bucket_1,\" \"bucket_2,\" \"bucket_3,\" and \"bucket_4,\" though the labels are \"1 Star,\" \"2 Stars,\" etc."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-lead-rating-2.png",
          alt: "Lead rating property in HubSpot UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Since internal values can't be updated once created, you may need to create a new custom property to accept data from your model. Refer to HubSpot's guide on ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/account/property-field-types-in-hubspot",
          children: "property field types"
        }), " to select the appropriate field type when creating new properties."]
      }), "\n", _jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsxs(_components.li, {
          children: ["Check if the property requires unique values: Click on its name, then go to ", _jsx(_components.strong, {
            children: "Rules"
          }), ". Under ", _jsx(_components.strong, {
            children: "Validation rules"
          }), ", see if ", _jsx(_components.strong, {
            children: "Require unique values for this property"
          }), " is checked. Properties you want to use for ", _jsx(_components.a, {
            href: "#record-matching",
            children: "record matching"
          }), " must have this validation."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-uniqueness.png",
          alt: "Inspecting a property's uniqueness"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsxs(_components.li, {
          children: ["Return to the object's overview page and select ", _jsx(_components.strong, {
            children: "Associations"
          }), ". Look for associated child objects like contacts, companies, or deals linked to the records. You can use these to map ", _jsx(_components.a, {
            href: "#associations",
            children: "associations"
          }), " in Hightouch. Add, remove, or correct links between objects as needed."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-association.png",
          alt: "Inspecting a property's associations"
        })
      }), "\n", _jsx(_components.p, {
        children: "Once you've validated the properties and associations of the objects you want to sync to, you're ready to configure your sync in Hightouch."
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-hubspot",
        children: "Connect to HubSpot"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "HubSpot"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to HubSpot with OAuth. If you plan on syncing events, select ", _jsx(_components.strong, {
          children: "OAuth with enterprise scopes"
        }), ". Otherwise, you can select ", _jsx(_components.strong, {
          children: "OAuth"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "Once successful, you will be redirected back to Hightouch to enter a descriptive name for your destination and complete setup."
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your HubSpot destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the HubSpot destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-objects",
        children: "Syncing objects"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch can create and update standard HubSpot objects such as contacts, companies, deals, etc. Hightouch can also sync data to custom HubSpot objects. To sync to a custom object, you must ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/crm-setup/use-custom-objects",
          children: "create it in HubSpot"
        }), " first."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsx(_components.p, {
        children: "To match rows from your model to objects in HubSpot, select a HubSpot property and the corresponding column from your model."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-record-matching.png",
          alt: "Record matching in the Hightouch UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can match on any of the available properties in the dropdown. It's best to select a property that ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/crm-setup/deduplication-of-contacts-companies-deals-tickets#deduplicate-companies-by-company-domain",
          children: "HubSpot automatically deduplicates on"
        }), ". These include email address or user token for contacts, company domain for companies, or record ids for other object types."]
      }), "\n", _jsxs(_components.p, {
        children: ["If you select a model column with duplicates to send to one of these properties, HubSpot ", _jsx(_components.a, {
          href: "#409---contact-already-exists",
          children: "returns a 409 error"
        }), " and the sync errors."]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["The ", _jsx(_components.code, {
            children: "id"
          }), " property is only available for record matching when in update mode.\nIt is a read-only property, and HubSpot sets its value upon object creation."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["The HubSpot property you select to match on should be ", _jsx(_components.strong, {
          children: "unique"
        }), ", and its data type must match the data type of the corresponding column in your model. If the property to match on isn't unique, record matching will be slower and duplicate records may occur. You can check a property's uniqueness validation by ", _jsx(_components.a, {
          href: "#inspect-objects-properties-and-associations",
          children: "inspecting the property in HubSpot"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["If the object doesn't have a native unique property, we recommend creating unique custom property. Refer to ", _jsx(_components.a, {
          href: "https://community.hubspot.com/t5/Tips-Tricks-Best-Practices/Custom-unique-property/td-p/683119#",
          children: "HubSpot's instructions"
        }), " on how to do so."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Field mapping lets you choose which properties you want to update on your HubSpot objects. If the HubSpot object you're syncing to doesn't have the specific property you want to send your data to, you need to ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/crm-setup/manage-your-properties",
          children: "create a new property on the object"
        }), " in HubSpot first."]
      }), "\n", _jsxs(Tip, {
        children: [_jsxs(_components.p, {
          children: ["You can also sync to ", _jsx(_components.a, {
            href: "https://knowledge.hubspot.com/account/property-field-types-in-hubspot",
            children: "enumeration\nproperties"
          }), ",\nsuch as ", _jsx(_components.strong, {
            children: "Dropdown select"
          }), ", ", _jsx(_components.strong, {
            children: "Radio select"
          }), ", and ", _jsx(_components.strong, {
            children: "Multiple checkboxes"
          }), ".\nMake sure to create your property's internal values before syncing them, as\nexplained in the ", _jsx(_components.a, {
            href: "#400---property-values-were-not-valid",
            children: "Common errors"
          }), "\nsection."]
        }), _jsx("br", {}), _jsxs(_components.p, {
          children: ["Check out ", _jsx(_components.a, {
            href: "https://knowledge.hubspot.com/crm-setup/import-data-to-checkbox-properties",
            children: "HubSpot's documentation"
          }), "\nto learn how to sync ", _jsx(_components.strong, {
            children: "Multiple checkboxes"
          }), "."]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["After creating or editing properties, you can refresh the available properties for mapping by clicking the refresh button next to ", _jsx(_components.strong, {
          children: "Field from HubSpot"
        }), ". The new property should then be available."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-refresh-fields.png",
          alt: "HubSpot internal naming"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch displays the property's ", _jsx(_components.strong, {
          children: "Internal name"
        }), ", not label, in the dropdown. You can find a property's internal name by ", _jsx(_components.a, {
          href: "#inspect-objects-properties-and-associations",
          children: "inspecting the property in HubSpot"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-inspect-internal-name.png",
          alt: "HubSpot internal naming"
        })
      }), "\n", _jsx(Info, {
        children: _jsx(_components.p, {
          children: "Read-only fields in HubSpot aren't available for mapping in Hightouch."
        })
      }), "\n", _jsx(_components.h4, {
        id: "associations",
        children: "Associations"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Associations"
        }), " let you express a relationship between the object you're syncing to (the ", _jsx(_components.strong, {
          children: "main object"
        }), ") and a different HubSpot object (the ", _jsx(_components.strong, {
          children: "associated object"
        }), ").\nFor example, you may be syncing contacts to HubSpot and want to associate a company with each one."]
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Add mapping"
        }), ", then select the association label under ", _jsx(_components.strong, {
          children: "Field from HubSpot"
        }), ".\nThe list of supported association labels for the object appears in the dropdown.\nYou can find an object's supported associations and add others by ", _jsx(_components.a, {
          href: "#inspect-objects-properties-and-associations",
          children: "inspecting the object in HubSpot"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["In Hightouch, you can search for the object you want to associate to (the ", _jsx(_components.strong, {
          children: "associated object"
        }), ").\nFor example, if you want to associate a company with each contact you're syncing, you can search for \"company.\" Then, select the appropriate association.\nIn this example, you would select ", _jsx(_components.strong, {
          children: "CONTACT_TO_COMPANY"
        }), "."]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["The association should only be set up in the main object's sync configuration.\nIn this example, you would only add it to the ", _jsx(_components.strong, {
            children: "Contact"
          }), " sync and not to the\n", _jsx(_components.strong, {
            children: "Company"
          }), " one. You can learn more about this in the ", _jsx(_components.a, {
            href: "#conflicting_one_to_ones_specified",
            children: "Common\nerrors"
          }), " section."]
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Make sure that the sync to the associated object always runs before the one to\nthe main object. After creating your syncs, you can ", _jsx(_components.a, {
            href: "/syncs/schedule-sync-with-sequences",
            children: "set up a\nsequence"
          }), " to schedule them in the correct\norder."]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-associations-list.png",
          alt: "Associations list in Hightouch"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Next, select the properties to match on. For example, if you're associating companies with contacts and a company's ", _jsx(_components.code, {
          children: "name"
        }), " matches the ", _jsx(_components.code, {
          children: "COMPANY_NAME"
        }), " in your contact data, you would select those properties."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-full-association.png",
          alt: "Associations list in Hightouch"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If your data contains the ", _jsx(_components.code, {
          children: "id"
        }), " of the object you want to associate to, it's best to use this column for matching. Since the sync doesn't have to perform a lookup, sync performance is significantly faster."]
      }), "\n", _jsxs(_components.p, {
        children: ["The example below shows using contact data that includes the associated company's id in a column called ", _jsx(_components.code, {
          children: "ACCOUNT_ID"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-full-association-with-id.png",
          alt: "Associations list in Hightouch"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can create multiple HubSpot associations in a single sync. Click ", _jsx(_components.strong, {
          children: "Add mapping"
        }), " for each association you want to make."]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information on associations, check out ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/crm-setup/associate-records",
          children: "HubSpot's association docs"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "association-modes",
        children: "Association modes"
      }), "\n", _jsx(_components.h5, {
        id: "create-added-associations",
        children: _jsx(_components.strong, {
          children: "Create added associations"
        })
      }), "\n", _jsx(_components.p, {
        children: "Associations will only be appended to the record. This setting will not remove previous associations if the associated object is updated or removed."
      }), "\n", _jsx(_components.h5, {
        id: "overwrite-existing-associations",
        children: _jsx(_components.strong, {
          children: "Overwrite existing associations"
        })
      }), "\n", _jsx(_components.p, {
        children: "When there are changes to associations in the source, remove all associations in HubSpot before creating the associations present in the source. If there are no changes to associations in the source, do not remove any associations."
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "This setting will also remove any associations that were created outside of\nHightouch."
        })
      }), "\n", _jsx(_components.h5, {
        id: "delete-removed-associations-and-create-added-associations",
        children: _jsx(_components.strong, {
          children: "Delete removed associations and create added associations"
        })
      }), "\n", _jsx(_components.p, {
        children: "This mode will find the differences between sync runs to delete associations in HubSpot that have been removed from the model, then create associations that have been added to the model."
      }), "\n", _jsx(_components.h4, {
        id: "one-to-many-relationships",
        children: "One-to-many relationships"
      }), "\n", _jsx(_components.p, {
        children: "You might want to associate the object you're syncing to with multiple objects of the same type. For example, if you're syncing company objects, you may want to link several contacts to each company."
      }), "\n", _jsx(_components.p, {
        children: "For Hightouch to associate multiple objects, the model column you select for the association must be in one of these formats:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["an array of string or number values, for example, ", _jsx(_components.code, {
            children: "[\"id1\", \"id2\", \"id3\"]"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["a comma-separated string, for example, ", _jsx(_components.code, {
            children: "\"id1, id2, id3\""
          })]
        }), "\n"]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Confirm that the association cardinality in your HubSpot settings is\ncompatible with the data you're syncing to HubSpot. You can learn more about\nthis in the ", _jsx(_components.a, {
            href: "#conflicting_one_to_ones_specified",
            children: "Common errors"
          }), " section."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "association-labels",
        children: "Association labels"
      }), "\n", _jsxs(_components.p, {
        children: ["If you have a Professional or Enterprise HubSpot account, you can also use HubSpot's ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/crm-setup/create-and-use-association-labels",
          children: "association labels feature"
        }), " to describe relationships between objects."]
      }), "\n", _jsx(_components.p, {
        children: "Association labels let you add descriptive text to an association that provides more context about the relationship. For example, instead of just linking a contact to a company, you can use an association label like \"Employee at\" or \"Customer of\" to clarify the nature of the relationship."
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Before configuring a sync to use association labels, check out HubSpot's\nassociation label limitations at the bottom of this ", _jsx(_components.a, {
            href: "https://developers.hubspot.com/docs/api/crm/associations/v4",
            children: "HubSpot\ndoc"
          }), "."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["To add association labels to a Hightouch sync, you must first ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/crm-setup/create-and-use-association-labels",
          children: "set up your labels in your HubSpot account"
        }), ". Then, you need to update the ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " column you use for associations to contain an object with this schema:"]
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-typescript",
          children: ["{ ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"value\""
          }), ": ", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "string"
          }), " | ", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "number"
          }), ", ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"label\""
          }), ": ", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "string"
          }), " | ", _jsx(_components.span, {
            className: "hljs-title class_",
            children: "Array"
          }), "<", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "string"
          }), "> }\n"]
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Make sure to set the model column's ", _jsx(_components.a, {
            href: "/models/data-types-casting#view-model-data-types",
            children: "data\ntype"
          }), " to ", _jsx(_components.strong, {
            children: "Object / Array"
          }), "."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch uses the ", _jsx(_components.strong, {
          children: "value"
        }), " to match the associated object and the ", _jsx(_components.strong, {
          children: "label"
        }), " as the label on the association in HubSpot. For example, if you're associating companies with contacts, you may set the company name as the value and the contact's role as the label."]
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-json",
          children: [_jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), " ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"value\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"ABC Corp\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), " ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"label\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Employee at\""
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: "If you want to add more than one label, the label can be an array of strings or a comma-separated list. For example, if you're associating companies with a contact and the contact has multiple roles, a row from your model might look like this:"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-json",
          children: [_jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), " ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"value\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"ABC Corp\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), " ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"label\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "["
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Employee at\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Decision maker\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "]"
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: "If you want to add more than one association label to an object, you can sync an array of association label objects.\nFor example, if you're associating billing data with multiple contacts, a row from your model might look like this:"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-css",
          children: [_jsxs(_components.span, {
            className: "hljs-selector-attr",
            children: ["[{ ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"value\""
            }), ": ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"John Doe\""
            }), ", ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"label\""
            }), ": ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"Buyer\""
            }), " }, { ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"value\""
            }), ": ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"Jane Doe\""
            }), ", ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"label\""
            }), ": ", _jsx(_components.span, {
              className: "hljs-string",
              children: "\"Seller\""
            }), " }]"]
          }), "\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Ensure ", _jsx(_components.strong, {
          children: "all"
        }), " rows follow this schema to avoid inconsistent behavior with HubSpot's API. If a row doesn't have a label, you can set the label as ", _jsx(_components.code, {
          children: "null"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "For example, suppose you want to associate a company with a contact but don't have any information about the contact's role there. The model row should look like this:"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-json",
          children: [_jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), " ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"value\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"ABC Corp\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), " ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"label\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "null"
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: "You can use some SQL helper functions to create an object or array of objects with this schema. Below is an example of a SQL query that creates an object for an association label:"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-sql",
          children: [_jsx(_components.span, {
            className: "hljs-keyword",
            children: "SELECT"
          }), "\n  id,\n  first_name,\n  last_name,\n  email,\n  JSONB_BUILD_OBJECT(", _jsx(_components.span, {
            className: "hljs-string",
            children: "'value'"
          }), ", company_name, ", _jsx(_components.span, {
            className: "hljs-string",
            children: "'label'"
          }), ", role) ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "as"
          }), " company_obj`\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["The query creates a column called ", _jsx(_components.code, {
          children: "company_obj"
        }), " and sets the ", _jsx(_components.code, {
          children: "company_name"
        }), " name as the value in the object and the ", _jsx(_components.code, {
          children: "role"
        }), " as the label in the object."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-sql-object-query.png",
          alt: "Model creation with association labels"
        })
      }), "\n", _jsx(_components.p, {
        children: "Once you've formatted the data correctly, ensure the association in your sync configuration uses the column with the properly formatted object."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-association-label.png",
          alt: "Association with association labels"
        })
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results. Depending on the ", _jsx(_components.a, {
          href: "#syncing-objects",
          children: "sync mode"
        }), " you're using, you can select from some or all of these options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the record in HubSpot"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Clear fields"
              })
            }), _jsx(_components.td, {
              children: "Keep the record, but clear the mapped fields"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Archive record"
              })
            }), _jsx(_components.td, {
              children: "Archive the record in HubSpot"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete record (Contacts only)"
              })
            }), _jsx(_components.td, {
              children: "GDPR Delete the record in HubSpot (Permanent delete)"
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["In Upsert mode, you can select from all of the above (", _jsx(_components.strong, {
          children: "Delete record"
        }), " for contacts only, performs a permanent delete using the ", _jsx(_components.a, {
          href: "https://developers.hubspot.com/docs/reference/api/crm/objects/contacts/v3#post-%2Fcrm%2Fv3%2Fobjects%2Fcontacts%2Fgdpr-delete",
          children: _jsx(_components.strong, {
            children: "GDPR delete"
          })
        }), " endpoint). In Update mode, you can only select between ", _jsx(_components.strong, {
          children: "Clear fields"
        }), " and ", _jsx(_components.strong, {
          children: "Archive record"
        }), ". Insert mode doesn't support delete behavior."]
      }), "\n", _jsx(_components.h4, {
        id: "split-retries",
        children: "Split retries"
      }), "\n", _jsxs(_components.p, {
        children: ["Hubspot counts all objects in a batch as rejected if the request contains a single invalid record.\nTo pinpoint which records are getting rejected with which errors and reduce the number of valid records that get retried,\nyou can enable ", _jsx(_components.a, {
          href: "/syncs/retries#split-retries",
          children: _jsx(_components.strong, {
            children: "split retries"
          })
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-events",
        children: "Syncing events"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch supports syncing ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/analytics-tools/create-codeless-custom-behavioral-events",
          children: _jsx(_components.strong, {
            children: "custom behavioral events"
          })
        }), " to HubSpot with custom properties. To sync events, ensure you logged in via ", _jsx(_components.strong, {
          children: "OAuth with enterprise scopes"
        }), " when you ", _jsx(_components.a, {
          href: "#connect-to-hubspot",
          children: "connected Hightouch to HubSpot"
        }), "."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "event-name",
        children: "Event name"
      }), "\n", _jsxs(_components.p, {
        children: ["Providing an event name is required to log an event in HubSpot. You can either provide a static value or select to ", _jsx(_components.strong, {
          children: "use a column"
        }), " from your model data."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-event-name.png",
          alt: "Track configuration in the Hightouch UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["The event name should match the event's ", _jsx(_components.strong, {
          children: "internal name"
        }), ". HubSpot assigns the internal name automatically when you create the event. You can find an event's internal name either in ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/analytics-tools/create-custom-behavioral-events#define-the-api-call",
          children: "HubSpot"
        }), " or by using the HubSpot ", _jsx(_components.a, {
          href: "https://legacydocs.hubspot.com/docs/methods/events/get_events",
          children: "events API"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Follow the instructions in HubSpot's docs to learn how to ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/analytics-tools/create-custom-behavioral-events#define-the-api-call",
          children: "find the internal name"
        }), " for an event."]
      }), "\n", _jsx(_components.h4, {
        id: "event-timestamp",
        children: "Event timestamp"
      }), "\n", _jsx(_components.p, {
        children: "You can optionally select a column that contains timestamps of when events occurred. If this field is empty, Hightouch uses the time the event arrives at the server."
      }), "\n", _jsx(_components.h4, {
        id: "assigning-events-to-contacts",
        children: "Assigning events to contacts"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch lets you choose how you assign events to contacts. Select a column in your events data that matches one of these HubSpot contacts identifiers:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "email"
        }), "\n", _jsx(_components.li, {
          children: "object (contact) ID"
        }), "\n", _jsx(_components.li, {
          children: "user token"
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-assign-contact-to-event.png",
          alt: "Contact assignment in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "In the field mapping section, you can select columns from your model to sync to the default or custom properties of a HubSpot custom behavioural event."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-event-mappings.png",
          alt: "Field mapping in the Hightouch UI"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Custom properties must exist on the event before you can sync to them. See\nHubSpot's docs on ", _jsx(_components.a, {
            href: "https://knowledge.hubspot.com/analytics-tools/create-custom-behavioral-events-with-the-code-wizard",
            children: "how to create a custom\nproperty"
          }), "\non an event."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "syncing-contact-lists",
        children: "Syncing contact lists"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch supports syncing contacts to ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/lists/create-active-or-static-lists",
          children: "contact lists"
        }), " in HubSpot. You can sync data to an existing contact list or create a new one on the first sync run. Select ", _jsx(_components.strong, {
          children: "Segment"
        }), " as the sync type."]
      }), "\n", _jsx(_components.h4, {
        id: "user-identifers",
        children: "User identifers"
      }), "\n", _jsxs(_components.p, {
        children: ["To identify which contacts to add or update in a contact list, select a model column and the corresponding HubSpot field.\nYou can match on either ", _jsx(_components.strong, {
          children: "Email"
        }), " or ", _jsx(_components.strong, {
          children: "HubSpot Contact ID"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-contact-list-id-mapping.png",
          alt: "Record matching in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "list-creation-or-selection",
        children: "List creation or selection"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports automatically creating a new list for your sync. You can specify a custom name for this list; if left empty, Hightouch defaults to the model name. The example below shows defaulting to the model name \"Newsletter subscribers.\""
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-lists-create.png",
          alt: "List creation in the Hightouch UI"
        })
      }), "\n", _jsx(_components.p, {
        children: "If you opt to sync to an existing list, you can select the list name from the dropdown."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "date-values",
        children: "Date values"
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing date or timestamp values to HubSpot, you need to consider which data type the HubSpot field should use: ", _jsx(_components.code, {
          children: "date"
        }), " or ", _jsx(_components.code, {
          children: "datetime"
        }), ".\nHubSpot ", _jsx(_components.code, {
          children: "date"
        }), " fields support date values which store a date without a time. ", _jsx(_components.code, {
          children: "datetime"
        }), " fields support timestamps. For more information, check out ", _jsx(_components.a, {
          href: "https://developers.hubspot.com/docs/api/faq#timestamps",
          children: "HubSpot's timestamp FAQ"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Values you send to a ", _jsx(_components.code, {
          children: "date"
        }), " field must follow one of these formats:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["date-only ISO 8601 strings (", _jsx(_components.code, {
            children: "YYYY-MM-DD"
          }), "), for example, ", _jsx(_components.code, {
            children: "2020-02-29"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["EPOCH-millisecond ", _jsx(_components.a, {
            href: "https://en.wikipedia.org/wiki/Unix_time",
            children: "timestamps"
          }), ", ", _jsx(_components.strong, {
            children: "with the time set to midnight UTC"
          }), ": for example, ", _jsx(_components.code, {
            children: "1430438400000"
          })]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "If you're syncing a timestamp to a date field, Hightouch automatically sets its time to midnight UTC, as required by HubSpot."
      }), "\n", _jsxs(_components.p, {
        children: ["Values you send to a ", _jsx(_components.code, {
          children: "datetime"
        }), " field values must follow one of these formats:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["ISO 8601 formatted strings (", _jsx(_components.code, {
            children: "YYYY-MM-DDThh:mm:ss.sTZD"
          }), "), for example, ", _jsx(_components.code, {
            children: "2020-02-29T03:30:17.000Z"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["EPOCH-millisecond ", _jsx(_components.a, {
            href: "https://en.wikipedia.org/wiki/Unix_time",
            children: "timestamps"
          }), ": for example, ", _jsx(_components.code, {
            children: "1427997766000"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["HubSpot displays ", _jsx(_components.code, {
          children: "datetime"
        }), " values in the timezone of the user viewing the record."]
      }), "\n", _jsx(TimestampTemplateMapping, {}), "\n", _jsxs(_components.p, {
        children: ["If you notice the timestamp from your Hightouch model column isn't appearing in Hubspot for your ", _jsx(_components.code, {
          children: "datetime"
        }), " field, edit the JSON mapping in your sync configuration to include ", _jsx(_components.code, {
          children: "\"skipDateParse\": true"
        }), ". See example below:"]
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-json",
          children: ["mappings", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "["
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"from\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"hightouch_datetime_column\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"to\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"hubspot_datetime_field\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"skipDateParse\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "true"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "]"
          }), "\n"]
        })
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "429---you-have-reached-your-secondly-limit",
        children: "429 - You have reached your secondly limit"
      }), "\n", _jsxs(_components.p, {
        children: ["You may receive a ", _jsx(_components.code, {
          children: "429 - You have reached your secondly limit"
        }), " error message for two reasons:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "You have another sync to HubSpot running simultaneously, which could make you reach HubSpot's secondly limit."
        }), "\n", _jsxs(_components.li, {
          children: ["You've set up ", _jsx(_components.a, {
            href: "#associations",
            children: "associations"
          }), " in your sync configuration. The HubSpot API has constraints that cause sync slowness when using associations."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["To reduce the occurrence of this error, ensure you're following ", _jsx(_components.a, {
          href: "#record-matching",
          children: "record matching configuration suggestions"
        }), ".\nFor more information about Hubspot's API limits and other 429 errors, ", _jsx(_components.a, {
          href: "https://developers.hubspot.com/docs/api/usage-details",
          children: "see Hubspot's API usage guidelines"
        }), "."]
      }), "\n", "\n", _jsx(_components.h4, {
        id: "409---contact-already-exists",
        children: "409 - Contact already exists"
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["You may receive a ", _jsx(_components.code, {
          children: "409 - Contact already exists"
        }), " or ", _jsx(_components.code, {
          children: "400 - Duplicate IDs found in batch input"
        }), " error for three reasons:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["the model column you are using for ", _jsx(_components.a, {
            href: "#record-matching",
            children: "record matching"
          }), " contains duplicate values"]
        }), "\n", _jsxs(_components.li, {
          children: ["the model column ", _jsx(_components.a, {
            href: "#field-mapping",
            children: "mapped"
          }), " to HubSpot's ", _jsx(_components.code, {
            children: "email"
          }), " field contains duplicate values"]
        }), "\n", _jsxs(_components.li, {
          children: ["you're attempting to create a ", _jsx(_components.strong, {
            children: "new"
          }), " contact in HubSpot that has the same ", _jsx(_components.code, {
            children: "email"
          }), " value as an already existing HubSpot contact, but a different value in the HubSpot field used for record matching (for example, ", _jsx(_components.code, {
            children: "user_id"
          }), ")"]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["HubSpot uses email as the primary unique identifier to avoid duplicate contacts.\nIn other words, two different contacts can't share the same email.\nSee ", _jsx(_components.a, {
          href: "https://developers.hubspot.com/docs/api/crm/contacts#properties",
          children: "HubSpot's Contacts API Reference"
        }), " for more information."]
      }), "\n", _jsx(_components.p, {
        children: "To resolve these errors, ensure:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "the column you selected for record matching doesn't contain duplicate values"
        }), "\n", _jsx(_components.li, {
          children: "any email information you are syncing also doesn't include duplicate values"
        }), "\n", _jsxs(_components.li, {
          children: ["you aren't attempting to create a ", _jsx(_components.strong, {
            children: "new"
          }), " HubSpot contact with the same email as an already existing one, but a different value in the record-matching field"]
        }), "\n"]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["The ", _jsx(_components.code, {
            children: "409 - Contact already exists"
          }), " error message contains an ", _jsx(_components.code, {
            children: "Existing ID"
          }), "\nvalue returned by HubSpot. This value refers to HubSpot's ID for the contact\nand doesn't necessarily correspond to any values in your model data."]
        })
      }), "\n", "\n", _jsx(_components.h4, {
        id: "400---cannot-update-object-with-type--the-following-properties-were-cleared-",
        children: "400 - Cannot update object with type ... the following properties were cleared ..."
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["You may receive a ", _jsx(_components.code, {
          children: "400 - Cannot update object with type: ... the following properties were cleared: ..."
        }), " because there is no data being sent to a required property in HubSpot. The properties listed after ", _jsx(_components.code, {
          children: "the following properties were cleared"
        }), " are the required property or properties.\nYou can resolve the error by either:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Removing records with empty values in the required property; you can update your ", _jsx(_components.a, {
            href: "/models/creating-models",
            children: "model definition"
          }), " to exclude rows like this"]
        }), "\n", _jsx(_components.li, {
          children: "Adding a value to the required property"
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "400---property-values-were-not-valid",
        children: "400 - Property values were not valid"
      }), "\n", _jsxs(_components.p, {
        children: ["You may receive a ", _jsx(_components.code, {
          children: "400 - {\"status\":\"error\",\"message\":\"Property values were not valid: [{\"isValid\":false,..."
        }), " error message because you are attempting to send a value to an ", _jsx(_components.a, {
          href: "https://knowledge.hubspot.com/account/property-field-types-in-hubspot",
          children: "enumeration property"
        }), " that isn't one of the valid options.\nEnumeration properties include ", _jsx(_components.strong, {
          children: "Dropdown select"
        }), ", ", _jsx(_components.strong, {
          children: "Radio select"
        }), ", and ", _jsx(_components.strong, {
          children: "Multiple checkboxes"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Ensure that the values exactly match the Hubspot's ", _jsx(_components.strong, {
          children: "Internal values"
        }), " and not the ", _jsx(_components.strong, {
          children: "Labels"
        }), ".\nThese values are case sensitive."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-hubspot-dropdown-internal-values.png",
          alt: "Dropdown select internal values in HubSpot"
        })
      }), "\n", _jsx(_components.p, {
        children: "The error message may contain lines like this:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "\"error\":\"INVALID_OPTION\",\"name\":\"custom_dropdown_field\"..."
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.code, {
            children: "\"error\":\"INVALID_OPTION\",\"message\": {...} was not one of the allowed options..."
          })
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["These can help pinpoint which Hubspot field is in question. Refer to step 4 of the ", _jsx(_components.a, {
          href: "#inspect-objects-properties-and-associations",
          children: "Inspect objects, properties, and associations"
        }), " section to find the ", _jsx(_components.strong, {
          children: "Internal Values"
        }), " of your Hubspot field."]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["As explained in the ", _jsx(_components.a, {
            href: "#field-mapping",
            children: "field mapping"
          }), " section, make sure to\nfollow ", _jsx(_components.a, {
            href: "https://knowledge.hubspot.com/crm-setup/import-data-to-checkbox-properties",
            children: "HubSpot's\nguidelines"
          }), "\nwhen syncing to ", _jsx(_components.strong, {
            children: "Multiple checkboxes"
          }), " fields."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "conflicting_one_to_ones_specified",
        children: "CONFLICTING_ONE_TO_ONES_SPECIFIED"
      }), "\n", _jsxs(_components.p, {
        children: ["This error can occur if you set up an ", _jsx(_components.a, {
          href: "#associations",
          children: "association"
        }), " both in the main object's and the associated object's sync configuration.\nIn this case, make sure to remove the association from the associated object's sync configuration."]
      }), "\n", _jsxs(_components.p, {
        children: ["This error can also happen if you add an association to your sync configuration, but the cardinality of your association or ", _jsx(_components.a, {
          href: "#association-labels",
          children: "association label"
        }), " in HubSpot isn't compatible with the data you're syncing.\nFor example, if the cardinality is set to ", _jsx(_components.code, {
          children: "1-to-1"
        }), " for the given association, your sync can't ", _jsx(_components.a, {
          href: "#one-to-many-relationships",
          children: "associate multiple records"
        }), " on the main object with one record on the associated object, or vice versa.\nTo resolve this, access the main object's HubSpot settings, open the ", _jsx(_components.strong, {
          children: "Associations"
        }), " tab, and check your associations' cardinalities.\nIn your Hightouch sync configuration, make sure to use an association or association label that has the correct cardinality."]
      }), "\n", _jsx(_components.h4, {
        id: "row-with-id-emailcould-not-be-added-to-the-list",
        children: "Row with ID email...could not be added to the list."
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["When syncing ", _jsx(_components.a, {
          href: "#syncing-contact-lists",
          children: "contact lists"
        }), " and ", _jsxs(_components.a, {
          href: "#user-identifers",
          children: ["matching on ", _jsx(_components.strong, {
            children: "Email"
          })]
        }), ", you may receive a ", _jsx(_components.code, {
          children: "Row with ID email...could not be added to the list"
        }), " error. This occurs when the contact you're trying to sync doesn't exist in your HubSpot workspace. To resolve this, ensure that the contact exists in HubSpot prior to syncing it to a contact list."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
